import { IntlShape } from 'react-intl';

import { ApiError } from '../../../api/types';

export const SCHEMA_EXAMPLE = {
  $schema: 'https://json-schema.org/draft/2020-12/schema',
  title: 'Example',
  description: 'JSON Schema example for user attributes. Not the actual schema.',
  properties: {
    game: {
      description: 'Name of the game played by a user.',
      type: 'string'
    },
    age: {
      description: "User's age.",
      type: 'integer'
    },
    had_ban: {
      description: 'Whether the user was banned.',
      type: 'boolean'
    },
    last_purchase: {
      description: "Date of user's last purchase.",
      type: 'string'
    }
  },
  additionalProperties: false,
  required: ['age', 'game', 'last_purchase'],
  type: 'object'
};

export const isStringJson = (str: string): boolean => {
  try {
    return JSON.parse(str);
  } catch (e) {
    return false;
  }
};

export const errorsMap = (intl: IntlShape, error: Required<ApiError>): string => {
  const { details } = error;

  const firstError = (details as Array<string>)[0];

  const invalidTypeRegexp = new RegExp(/properties\..*\.type must be one of the following/);
  const propertiesRequired = new RegExp(/properties is required/);
  const propertiesInvalidType = new RegExp(/properties: Invalid type./);

  switch (true) {
    case invalidTypeRegexp.test(firstError): {
      const name = firstError.slice(
        firstError.indexOf('properties.') + 11,
        firstError.indexOf('.type:')
      );

      return intl.formatMessage({ id: 'user-data-base.settings.attributes.error.type' }, { name });
    }
    case propertiesRequired.test(firstError):
      return intl.formatMessage({
        id: 'user-data-base.settings.attributes.error.properties-required'
      });
    case propertiesInvalidType.test(firstError):
      return intl.formatMessage(
        { id: 'user-data-base.settings.attributes.error.type' },
        { name: 'properties' }
      );
    default:
      return intl.formatMessage({ id: 'user-data-base.settings.attributes.error.default' });
  }
};
